import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getKitToken, saveKitToken } from '../utils/storage';
import './InstructionsPage.css';

export function InstructionsPage() {
  const navigate = useNavigate();
  const [hasToken, setHasToken] = useState(!!getKitToken());

  const handleStartStudy = () => {
    saveKitToken();
    setHasToken(true);
    // Force a reload or navigate to home to refresh states
    window.location.hash = '#/';
    window.location.reload();
  };

  const handleBackToHome = () => {
    navigate('/');
  };

  return (
    <div className="kit-instructions-page-standalone">
      <div className="instruction-header-standalone">
        <span className="instruction-leaf-standalone">🍃</span>
        <h2>Culture Probe</h2>
        <p className="instruction-sub-standalone">Food Journey Experiment</p>
      </div>

      <div className="instruction-body-standalone">
        <div className="instruction-card-standalone">
          <h4>Welcome to our Study!</h4>
          <p>This is a <strong>Culture Probe Kit</strong> designed to explore your daily eating patterns, decisions, and immediate emotional states.</p>
        </div>

        <div className="instruction-card-standalone">
          <h4>What you will do:</h4>
          <ul>
            <li>📷 <strong>Photograph Meals</strong>: Log what you eat with visual snapshots via your device camera.</li>
            <li>🎙️ <strong>Record Memos</strong>: Record brief voice recordings describing your dining state.</li>
            <li>📍 <strong>Tag Locations</strong>: Mark campus or off-campus eating hotspots on the interactive map.</li>
            <li>🎭 <strong>Slider Emotions</strong>: Track feelings before, during, and after eating.</li>
          </ul>
        </div>

        <div className="instruction-card-standalone note-card-standalone">
          <p>💡 <em>Note: Your voice recordings and ratings are used solely to study dining social context and decision-making factors.</em></p>
        </div>
      </div>

      <div className="instruction-action-area-standalone">
        {!hasToken ? (
          <button className="start-study-btn-standalone" onClick={handleStartStudy}>
            Acknowledge & Start ➔
          </button>
        ) : (
          <button className="back-study-btn-standalone" onClick={handleBackToHome}>
            ◀ Back to Home Screen
          </button>
        )}
      </div>
    </div>
  );
}
export default InstructionsPage;
